import { useFetchCheckbetTicket } from "../../../fetchCheckbetTicket";
import { getLabel } from "../../../labels";
import TupleInfo from "../../TupleInfo";
import EventsList from "../EventsList";

function CheckBetSnapshotUI({ ticketId, hideAmounts, isSnapshot }) {
    const [request] = useFetchCheckbetTicket(ticketId, true, false, false, true);

    if (!request.data) {
        return <div>{getLabel('general.loading', 'Caricamento')}</div>;
    }

    const data = request.data;

    return (
        <div className="mb-share-snapshot-events">
            <EventsList
                events={data.events}
                isSnapshot={isSnapshot}
                isSystem={data.type === 'systembets'}
                hideAmounts={hideAmounts}
                isCheckbet={true}
            />
            {data.type === 'systembets' && data.tuples && (
                <TupleInfo
                    tuples={data.tuples}
                    ticketId={ticketId}
                    hideAmounts={hideAmounts}
                />
            )}
        </div>
    );
}

export default CheckBetSnapshotUI;